import { useState } from 'react';
import PropTypes from 'prop-types';

import { analytics, getFaqOpen } from '@/utils/analytics';

import QuestionItem from '@/molecules/Question/QuestionItem';

export default function Question({ questions, entries }) {
  const [activeId, setActiveId] = useState();

  const toggleQuestion = (e, questionId, question) => {
    if (activeId === questionId) {
      return setActiveId(null);
    }
    if (questionId) {
      analytics({
        window,
        document,
        detail: getFaqOpen(e, { linkText: question, id: questionId }),
      });
    }
    return setActiveId(questionId);
  };

  return (
    <>
      {questions?.length > 0 &&
        questions.map(
          ({ fields: { answer, question }, sys: { id: questionId } }, index) => {
            return (
              <QuestionItem
                entries={entries}
                index={index}
                answer={answer}
                id={questionId}
                isOpen={activeId === questionId}
                key={questionId}
                question={question}
                toggleQuestion={toggleQuestion}
              />
            );
          }
        )}
    </>
  );
}

Question.propTypes = {
  questions: PropTypes.array,
};
